import { useContext } from 'react';

import { BackgroundTaskContext } from './BackgroundTaskProvider';

export const useBackgroundTasks = () => {
  return useContext(BackgroundTaskContext);
};
